import enLang from 'antd/es/locale/en_US';
import arLang from 'antd/es/locale/ar_EG';


const AppLocale = {
  en: enLang,
  ar: arLang,
};

export default AppLocale;
